/**
 * GameStakeSelector.ts
 */
import { StakeSelector } from "@lib/titan2-slingo/dist/game/view/abstract/display/StakeSelector";
import { DestroyUtil } from "@lib/titan2/dist/util/view/DestroyUtil";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
export class GameStakeSelector extends StakeSelector {
    create() {
        this.mouseBlocker = new MouseBlocker(new MouseBlockerProperties(0x000000, 0.72));
        this.addChild(this.mouseBlocker);
        this.mouseBlocker.hide();
        super.create();
    }
    updateValues() {
        this.destroyPanelChildren(this.panel);
        this.createValueButtons();
        this.createTop(this.panel);
        this.createBottom(this.panel);
        this.createValueHolderMask();
        this.refresh(false);
    }
    destroyPanelChildren(panel) {
        for (let i = 0; i < panel.getTotalChildren(); i++) {
            const child = panel.getPanelChildAt(i);
            DestroyUtil.destroy(child);
        }
        this.panel.removeAll();
    }
    handleToggleButtonSelected() {
        super.handleToggleButtonSelected();
        this.toggleButton.isSelected()
            ? this.dispatchCore(CommonGameEvent.STAKE_SELECTOR_OPEN)
            : this.dispatchCore(CommonGameEvent.STAKE_SELECTOR_CLOSE);
    }
    open() {
        super.open();
        this.mouseBlocker.show();
    }
    close() {
        super.close();
        this.mouseBlocker.hide();
    }
    handleResize(event) {
        super.handleResize(event);
        requestAnimationFrame(() => this.mouseBlocker.fitToWindow());
    }
}
//# sourceMappingURL=GameStakeSelector.js.map